import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BcMessagesComponent } from './bc.messages.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    BcMessagesComponent
  ],
  exports: [
    BcMessagesComponent
  ]
})
export class BcMessagesModule {  }
